import { Box, TableContainer, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { cfFreezeNames } from '../../../../theme/theme';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: 0,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
}));

export const StyledGridHeaderContainer = styled(Box)(({ theme }) => ({
  zIndex: 5,
  backgroundColor: theme.palette.grey[200],

  textTransform: 'uppercase',
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
}));

export const StyledGridHeaderRow = styled(Box)<{ sx?: SxProps<Theme> }>(({ theme, sx }) => ({
  ['&']: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: 'inherit',
    borderRadius: 'inherit',
    ...theme.typography.paragraphHeaderBold,
    ...sx,
  },
}));

export const StyledGridHeaderCell = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
}));

/**
 * @summary used in CfDataGridTableView to make table header sticky
 */
export const StyledStickyTableHead = styled(Box)<{ tableClassName?: string | undefined; sx?: SxProps<Theme> }>(
  ({ theme, tableClassName, sx }) => ({
    [theme.breakpoints.up('xl')]: {
      position: 'sticky',
      top: theme.custom.sticky.getTotalHeightOfComponents([
        cfFreezeNames.header,
        cfFreezeNames.breadcrumb,
        cfFreezeNames.pageHeader,
        tableClassName ? tableClassName : cfFreezeNames.contentHeader,
      ]),
      zIndex: theme.custom.sticky.zIndex[cfFreezeNames.tableHeader],
    },
    ...sx,
  })
);
